import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetch({ commit, dispatch }) {
        return ajax.get("Procurements/api/CurrencyExchangesQuery/by-paging").then(r => {
          commit("setList", r.data.data);
          return r.data.data;
        });
      },
      currencyList({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Procurements/api/CurrencyExchangesQuery/" + id)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    createCurrency({ commit, dispatch }, model) {
        return ajax.post("Procurements/api/CurrencyExchange", model).then(() => {
          dispatch("fetch");
        });
      },
    editCurrency({ commit, dispatch }, model) {
        return ajax.put("Procurements/api/CurrencyExchange", model).then(() => {
          dispatch("fetch");
        });
      },
    deleteCurrency({ commit, dispatch }, model) {
        return ajax.delete("Procurements/api/CurrencyExchange", { data: { id: model } },).then(() => {
          dispatch("fetch");
        });
      }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
